import { render, staticRenderFns } from "./ClusterCompanyForm.vue?vue&type=template&id=defd823c"
import script from "./ClusterCompanyForm.vue?vue&type=script&lang=js"
export * from "./ClusterCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports